<!--  -->
<template>
  <div class="card_wrap" style="">
    <div class="header_wrap">
      <p class="header_p">
        派送费设置<el-divider direction="vertical"></el-divider>
      </p>
      <el-form
  
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="目的国家">
          <el-select clearable  v-model="formInline.countryId" @change="changeCountry(formInline.countryId)">
            <el-option
              
              v-for="item in countAll"
              :key="item.id"
              :label="item.namec"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目的仓库">
          <el-select clearable  v-model="formInline.warehouseId">
            <el-option
              v-for="item in CangkuLIst"
              :key="item.id"
              :label="item.namec"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select clearable  v-model="formInline.status">
            <el-option
              v-for="item in statusLIst"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getShowcount()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button type="success"  @click="addFrom()">新增</el-button>
    </div>
    <div class="Center_wrap">
      <template>
        <el-table
          size="mini"
          max-height="700px"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          border
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column type="index" align="center" label="序号" width="50">
          </el-table-column>
          <el-table-column align="center" prop="country" label="目的国家" width="180">
          </el-table-column>
          <el-table-column align="center" prop="warehouse" label="目的仓库">
          </el-table-column>
          <el-table-column align="center" prop="chargeType" label="计费单位">
          </el-table-column>
          <el-table-column align="center" prop="currency" label="币种">
          </el-table-column>
          <el-table-column align="center" prop="price" label="单价">
          </el-table-column>
          <el-table-column align="center" prop="lowestFee" label="最低收费">
          </el-table-column>
          <el-table-column align="center" prop="state" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.state==1?'草稿':scope.row.state==2?'提交':scope.row.state==3?'审核通过':scope.row.state==4?'审核不通过':scope.row.state==5?'作废':''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="effectiveStartTime" label="生效日期">
          </el-table-column>
          <el-table-column align="center" prop="effectiveEndTime" label="失效日期">
          </el-table-column>
          <el-table-column align="center" prop="submitter" label="提交人">
          </el-table-column>
          <el-table-column align="center" prop="submitTime" label="提交时间">
          </el-table-column>
          <el-table-column align="center" prop="reviewer" label="审核人">
          </el-table-column>
          <el-table-column align="center" prop="reviewTime" label="审核时间">
          </el-table-column>
          <el-table-column align="center" prop="reviewReason" label="审核原因">
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button slot="reference"  size="mini" @click="setItem(scope.row)">查看</el-button>
              <el-button
                v-if="scope.row.state==1||scope.row.state==4"
                size="mini"
                type="warning"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button v-if="scope.row.state==1" slot="reference" @click="tableDelete(scope.row)" type="danger"  size="mini">删除</el-button>
              <el-button
                v-if="scope.row.state==1||scope.row.state==4"
                size="mini"
                type="success"
                @click="Qdsubim(scope.row)"
                >提交</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="TB_center" style="width: 100%; margin-top: 50px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="prev, pager, next" :total="countlisttotal"></el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog
      width="1250px"
      center
      title="派送费"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        label-position="left"
        :inline="true"
        :model="ruleform"
        :rules="moreNotOjb"
        ref="ruleForm" 
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label-width='100px'
              label="目的国家"
              prop="countryId"
            >
              <el-select
                @change="changeCity(ruleform.countryId)"
                style="width:400px"
                v-model="ruleform.countryId">
                <el-option
                  v-for="item in countAll"
                  :key="item.id"
                  :label="item.namec"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label-width='100px'
              label="计费单位" prop="chargeType">
              <el-select
                style="width:400px"
                v-model="ruleform.chargeType">
                <el-option
                  v-for="item in ChargeTypeAll"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width='100px'
               prop="currency" label="币种" class="boxTetx" >
              <el-select style="width:400px" v-model="ruleform.currency" placeholder="请选择">
                <el-option
                v-for="item in currencyList"
                :key="item.name"
                :label="item.name"
                :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label-width='100px'
              prop="price"
              label="单价"
            >
              <el-input style="width:400px" v-model="ruleform.price" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item prop="lowestFee" label-width='100px'
              label="最低收费" class="boxTetx" >
              <el-input style="width:400px" v-model="ruleform.lowestFee" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item   prop="hiveTime" label="有效时间" label-width="100px">
            <div class="block">
              <el-date-picker
              style="width:400px"
                 v-model="ruleform.hiveTime"
                 @change="changeTime(ruleform.hiveTime)"
                 format='yyyy-MM-dd HH:mm:ss'
                 value-format='yyyy-MM-dd HH:mm:ss'
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
          
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" label-width="100px">
            <el-input
              style="width:1010px"
              v-model="ruleform.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        style="
          width: 100%;
          float: left;
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
        "
      >
        <el-transfer
          filterable
          :titles="['请选择要分配的仓库', '已分配目的地仓库']"
          :filter-method="filterMethod"
          filter-placeholder="请输入城市拼音"
          v-model="ruleform.detailList"
          :props="{
            key: 'id',
            label: `namec`,
          }"
          :data="cityList"
        >
        </el-transfer>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="setQd()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看 -->
    <el-dialog
      width="1250px"
      center
      title="查看派送费"
      :visible.sync="setDatatype"
    >
     <el-row :gutter="20">
      <div style="margin-bottom:25px;width:100%;float:left">
          <el-col :span="7">
          <span class="settit">目的地国家</span>
          <span class="setTest">{{setCount.countryName}}</span>
          </el-col>
          <el-col :span="6">
            <span class="settit">计费单位</span>
            <span class="setTest">{{setCount.chargeType}}</span>
          </el-col>
          <el-col :span="11">
            <span class="settit">币种</span>
            <span class="setTest">{{setCount.currency}}</span>
          </el-col>
      </div>
      <div style="margin-bottom:25px;width:100%;float:left">
          <el-col :span="7">
          <span class="settit">单价</span>
            <span class="setTest">{{setCount.price}}</span>
          </el-col>
          <el-col :span="6">
            <span class="settit">最低收费</span>
            <span class="setTest">{{setCount.lowestFee}}</span>
          </el-col>
           <el-col :span="11">
            <span class="settit">有效时间</span>
            <span class="setTest">{{setCount.effectiveStartTime}}--{{setCount.effectiveEndTime}}</span>
          </el-col>
      </div>
      <el-col :span="24">
        <span class="settit">备注</span>
        <span class="setTest">{{setCount.remarks}}</span>
      </el-col>
    </el-row>
    <div style="width:100%;margin-top:35px" >
           <el-table
            :data="setList"
            style="width: 100%">
            <el-table-column
              align='center'
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
            align='center'
              prop="namec"
              label="仓库">
            </el-table-column>
          </el-table>
    </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setDatatype = false">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import qs from "qs";
export default {
  components: {},
  data() {
    return {
      setList:[],
      cityList:[],
      ChargeTypeAll:[],
      CangkuLIst:[],
      VIPList: [],
      setCount:{},//查询数据
      setDatatype:false,
      fillList:[],//增值服务
      currencyList:[],
      busAlllist:[
        {name:'FBA',id:0},
      ],
      statusLIst:[
        {name:'全部',id:0},
        {name:'草稿',id:1},
        {name:'已提交',id:2},
        {name:'审核通过',id:3},
        {name:'审核不通过',id:4},
        {name:'作废',id:5},
      ],

      priceTypeLits:[
        {name:'一口价',id:1},
        {name:'阶梯价',id:2},
      ],
       moreNotOjb: {
          countryId: [{ required: true, message: "国家不能为空", trigger: 'blur'}],
          chargeType: [{ required: true, message: "计费单位不能为空", trigger: 'blur'}],
          currency: [{ required: true, message: "币种不能为空", trigger: 'blur'}],
          hiveTime: [{ required: true, message: "有效时间不能为空", trigger: 'blur'}],
          lowestFee:[
            { required: true, message: "最低收费不能为空", trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if(value){
                if (value.length > 15 || value.length < 1) {
                callback(new Error("只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("只能大于零且保留2位小数"));
                } else {
                  callback();
                }
              }
              }else{
                callback();
              }
              
            },
            trigger: "change",
          },
        ],
        price:[
          { required: true, message: "单价不能为空", trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if(value){
                if (value.length > 15 || value.length < 1) {
                callback(new Error("只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("只能大于零且保留2位小数"));
                } else {
                  callback();
                }
              }
              }else{
                callback();
              }
              
            },
            trigger: "change",
          },
        ],
      },
      ruleform: {
        "chargeType": "",
        "countryId": '',
        "currency": "",
        "detailList":[],
        "effectiveEndTime": "",
        "effectiveStartTime": "",
        "id": '',
        "lowestFee":'',
        "price":'',
        "remarks": "",
         hiveTime:[],//开始结束日期数组
        },
      pageNum:1,
      countlisttotal:0,
      countAll: [],
      yunshuList: [
        {name:'海运',id:'HY'},
        {name:'空运',id:'KY'},
        {name:'陆运',id:'LY'},
      ],
      checkedCitylist: [],
      filterMethod(query, item) {
        return item.namec.indexOf(query) > -1;
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      formInline: {
        status: "",
        countryId: "",
        warehouseId:''
      },
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    tableDelete(item){ //删除
    console.log(item)
    let that = this
        this.$confirm('确定删除该数据吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              that.axios
                .get(`/carrier/deliverPrice/deleteCarrierProductAdd/${item.id}`)
                .then((res) => {
                  that.getShowcount()
                })
                .catch(function (error) {
                  console.log(error);
                });
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    changeCity(id) {//切换城市
      this.getcityAll(id);
    },
    getcityAll(id) {
      this.axios
        .get(`/filedata/findCountryCityAll/${id}`)
        .then((res) => {
          this.cityList = res.data.datas;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeCountry(id){
      this.formInline.warehouseId = ''
      this.CangkuLIst = []
       this.axios
        .get(`/filedata/findCountryCityAll/${id}`)
        .then((res) => {
          console.log(res.data)
          this.CangkuLIst = res.data.datas
        })
        .catch(function (error) {
          console.log(error);
        }); 
    },
    setItem(item){ //查看
        this.axios
        .get(`/carrier/deliverPrice/getCarrierProductAddInfo/${item.id}`)
        .then((res) => {
          console.log(res.data)
          this.setDatatype = true
          this.setList = []
          res.data.data.warehouseList.forEach((item)=>{
            res.data.data.detailList.forEach(_item=>{
              if(item.id==_item){
                this.setList.push(item)
              }
            })
          })
          console.log(this.setList)
          this.setCount = res.data.data
         
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    Qdsubim(item){ //提交
        let that = this
        this.$confirm('提交该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios
            .get(`/carrier/deliverPrice/submitCarrierProductAdd/${item.id}`)
            .then((res) => {
              console.log(res)
                if(res.data.code==-1){
                    that.$message({type: "info",message:res.data.message})
                }else{
                  that.pageNum = 1
                  that.getShowcount()
                  that.$message({type: "success",message:'成功'})
                }
                  
            })
            .catch(function (error) {
              console.log(error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
        
    },
    getVIPAll() {
      this.axios
        .post(`/filedata/findFbaVipInfoAll`)
        .then((res) => {
          console.log(res.data)
          this.VIPList = res.data.datas;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setQd() {
      let that =this
      this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            if(that.ruleform.detailList.length<=0) return that.$message({type: "info",message:'请选择分配的仓库'})
            that.POstdata()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    POstdata(){
      let params = this.ruleform
      this.axios
        .post("/carrier/deliverPrice/insertOrUpdateCarrierProductAdd", params)  
        .then((res) => {
          console.log(res);
          if(res.data.code==-1){
               this.$message({type: "info",message:res.data.message})
            }else{
              this.dialogFormVisible = false
              this.pageNum = 1
              this.getShowcount()
              this.$message({type: "success",message:res.data.message})
            }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeTime(item){
      console.log(item)
      this.ruleform.effectiveStartTime = item[0]
      this.ruleform.effectiveEndTime = item[1]
    },
    getcurrencydata(){ //获取所有币种
      this.axios
        .get(`/filedata/findCurrencyAll`)
        .then((res) => {
          
          res.data.datas.forEach(item=>{
            let obj = {
              name:item
            }
            this.currencyList.push(obj)
          })
          console.log(this.currencyList)
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    handleEdit(index,item){ //修改前查看
      this.axios
        .get(`/carrier/deliverPrice/getCarrierProductAddInfo/${item.id}`)
        .then((res) => {
          console.log(res)
          this.changeCity(res.data.data.countryId);
          this.ruleform.hiveTime[0] = res.data.data.effectiveStartTime
          this.ruleform.hiveTime[1] = res.data.data.effectiveEndTime
          this.ruleform.chargeType = res.data.data.chargeType
          this.ruleform.countryId = res.data.data.countryId
          this.ruleform.currency = res.data.data.currency
          this.ruleform.detailList =  res.data.data.detailList
          this.ruleform.effectiveEndTime = res.data.data.effectiveEndTime
          this.ruleform.effectiveStartTime = res.data.data.effectiveStartTime
          this.ruleform.id = res.data.data.id
          this.ruleform.lowestFee = res.data.data.lowestFee
          this.ruleform.price = res.data.data.price
          this.ruleform.remarks = res.data.data.remarks
          this.dialogFormVisible = true
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    
    geicountAll() {
      //获取所有国家
      this.axios
        .post("/filedata/findCarrierLinkCountryAll")
        .then((res) => {
          this.countAll = res.data.datas;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    geiChargeTypeAll() {
      //获取FBA计费方式列表
      this.axios
        .post("/filedata/findFbaChargeTypeAll")
        .then((res) => {
          res.data.datas.forEach(item=>{
            let obj = {
              name:item
            }
            this.ChargeTypeAll.push(obj)
          })
          

          console.log(res)
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val
        this.getShowcount()
      },
    getShowcount() {//查询列表数据
      let params = {
        countryId: this.formInline.countryId,
        pageNum:this.pageNum,
        pageSize:20,
        status:this.formInline.status==0?'':this.formInline.status,
        warehouseId:this.formInline.warehouseId,
      };
      this.axios
        .post("/carrier/deliverPrice/getDeliverPriceList", params)
        .then((res) => {
          console.log(res)
          this.tableData = res.data.data.list
          this.countlisttotal = res.data.data.total
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addFrom() { //初始化数据
          this.dialogFormVisible = true;
          this.ruleform.chargeType =''
          this.ruleform.countryId =''
          this.ruleform.currency =''
          this.ruleform.detailList=[]
          this.ruleform.effectiveEndTime =''
          this.ruleform.effectiveStartTime =''
          this.ruleform.id =''
          this.ruleform.lowestFee =''
          this.ruleform.price =''
          this.ruleform.remarks =''
          this.ruleform.hiveTime = []
          
    },
  },

  created() {},
  mounted() {
    this.geiChargeTypeAll()
    this.getVIPAll()
    this.geicountAll();
    this.getShowcount()
    this.getcurrencydata()
  },
};
</script>
<style  scoped>
.Boxcard{
    margin-bottom: 15px;
    border-radius: 15px;
}
.grid-content {
  min-height: 36px;
  text-align: center;
  height:46px;
}
.boxwrap >>> .el-card__body {
  padding:10px !important;
}
.setTest{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left:30px
}
.settit{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.card_wrap {
  padding: 30px;
  background: rgb(255, 255, 255);
  box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
  border-radius: 10px;
}
.header_p {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 35px;
}
.Center_wrap {
  margin-top: 35px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/QuotationManagement/Delivery.vue